/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : SortTemplate.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import CustomRadioButtonV2 from "../radioButton/CustomRadioButtonV2";
import sortUp from "../../../../assets/sortup.png";
import sortDown from "../../../../assets/sortdown.png";

function SortTemplate({ handleOnChange, defaultValue, restrictField }) {
  const [sortValue, setSortValue] = useState({
    sortBy: "created_at",
    sortOrder: "ASC",
  });

  useEffect(() => {
    if (defaultValue) {
      setSortValue(defaultValue);
    }
  }, [defaultValue]);
  return (
    <Box>
      <Box>
        <Box sx={{ p: 2 }}>
          <CustomRadioButtonV2
            value={sortValue.sortBy}
            onChange={(e) =>
              setSortValue((prev) => {
                let newSortValue = { ...prev, sortBy: e.target.value };
                handleOnChange(newSortValue);
                return newSortValue;
              })
            }
            data={[
              { value: "created_at", label: "Created at" },
              { value: "updated_at", label: "Updated at" },
            ].filter((item) => !restrictField?.includes(item.value))}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",

            gap: 0.5,
          }}
        >
          <Box
            component="button"
            type="button"
            onClick={() =>
              setSortValue((prev) => {
                let newSortValue = {
                  ...prev,
                  sortOrder: "ASC",
                };
                handleOnChange(newSortValue);
                return newSortValue;
              })
            }
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              cursor: "pointer",
              px: 1.5,
              py: 0.75,
              border: "none",
              borderRadius: 0,
              backgroundColor:
                sortValue?.sortOrder === "ASC" ? "#26890D" : "transparent",
              color: sortValue?.sortOrder === "ASC" ? "#FFFFFF" : "#000000",
              width: "100%",
              textAlign: "left",
            }}
          >
            <img
              src={sortUp}
              alt="Sort Asc–Des"
              style={{ width: 16, height: 16 }}
            />
            <Typography variant="body2" sx={{ color: "inherit" }}>
              Sort Asc – Des
            </Typography>
          </Box>

          <Box
            component="button"
            type="button"
            onClick={() =>
              setSortValue((prev) => {
                let newSortValue = {
                  ...prev,
                  sortOrder: "DESC",
                };
                handleOnChange(newSortValue);
                return newSortValue;
              })
            }
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              cursor: "pointer",
              px: 1.5,
              py: 0.75,
              border: "none",
              borderRadius: 0,
              backgroundColor:
                sortValue?.sortOrder === "DESC" ? "#26890D" : "transparent",
              color: sortValue?.sortOrder === "DESC" ? "#FFFFFF" : "#000000",
              width: "100%",
              textAlign: "left",
            }}
          >
            <img
              src={sortDown}
              alt="Sort Des–Asc"
              style={{ width: 16, height: 16 }}
            />
            <Typography variant="body2" sx={{ color: "inherit" }}>
              Sort Des – Asc
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

SortTemplate.propTypes = {
  handleOnChange: PropTypes.func,
  defaultValue: PropTypes.shape({
    sortBy: PropTypes.string,
    sortOrder: PropTypes.string,
  }),
  restrictField: PropTypes.arrayOf(PropTypes.string),
};

SortTemplate.defaultProps = {
  handleOnChange: () => {},
  defaultValue: null,
  restrictField: [],
};

export default SortTemplate;
